import Vue from 'vue'
import Vuex from 'vuex'
import global from './modules/global'
import bases from './modules/bases'
import tablas from './modules/tablas'

Vue.use(Vuex)


export default new Vuex.Store({
  modules: {
    global,
    bases,
    tablas,
  }
})
